import type { oz } from '@weft/utils';
import { BaseConfigurationSchema } from '../configuration/base-configuration-schema';

export const HubspotIntegrationConfigurationSchema = BaseConfigurationSchema.extend({
}).openapi('HubspotIntegrationConfiguration');

export type HubspotIntegrationConfiguration = oz.infer<typeof HubspotIntegrationConfigurationSchema>;